import { Seo } from "@/components/Seo";
import { useLang } from "@/i18n";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquees";
import { About } from "@/components/About";
import { ProductRange } from "@/components/ProductRange";
import { ColourSpectrum } from "@/components/ColourSpectrum";
import { KeyNumbers, FinderEntry, ExportBlock } from "@/components/HomeBlocks";
import { Exhibitions } from "@/components/Exhibitions";
import { Quality } from "@/components/Sections";

export default function HomePage() {
  const { t } = useLang();

  return (
    <>
      <Seo title={t.seo.home.title} description={t.seo.home.description} path="/" />
      <Hero />
      <About />
      <ProductRange simple />
      <FinderEntry />
      <ColourSpectrum />
      <KeyNumbers />
      <Exhibitions showPast={false} />
      <ExportBlock />
      <Quality />
      <EditorialMarquee />
    </>
  );
}
